<template>
  <div class="footer">
    <div class="title">
      <div class="title-left">
        <img src="@/assets/images/logo.png" alt="">
        <div class="leftInfo">
          <span>{{ $t('platform.footer.title1') }}</span>
          <p>{{ $t('platform.footer.title2') }}</p>
          <div class="bot">
            <span>{{ $t('platform.footer.title3') }}</span>
            <span>{{ $t('platform.footer.title4') }}</span>
            <span>{{ $t('platform.footer.title5') }}</span>
          </div>
        </div>
      </div>
      <div class="title-right">
        <div class="top">
          <img src="@/assets/images/home/gbApp.png" alt="">
          <p/>
          <span>{{ $t('platform.footer.title6') }}</span>
        </div>
        <div class="bot">
          <a href="https://www.tsa.cn" target="_blank"><img src="@/assets/images/home/tsaLogo.png" alt=""></a>
          <p/>
          <span>{{ $t('platform.footer.title7') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {},
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {},
}

</script>
<style scoped lang='less'>
.footer {
  height: 310px;
  background: #002972;

  .title {
    padding: 51px 0;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: center;

    .title-left {
      display: flex;

      img {
        width: 196px;
        height: 196px;
        margin-right: 40px;
      }

      .leftInfo {
        margin: 25px 0 0;

        span, p {
          color: #FFFFFF;
          display: block;
        }

        span {
          font-size: 30px;
          letter-spacing: 3px;
          font-weight: 500;
          line-height: 35px;
        }

        p {
          font-size: 15px;
        }

        .bot {
          margin-top: 37px;

          span {
            font-size: 14px;
            line-height: 16px;
            margin-bottom: 9px;
          }
        }
      }
    }

    .title-right {
      border-left: 1px solid #FFFFFF;
      padding-left: 20px;

      .top {
        display: flex;
        border-bottom: 1px solid #FFFFFF;
        padding-bottom: 15px;
        align-items: center;

        img {
          width: 128px;
          height: 128px;
        }

        p {
          width: 0;
          height: 0;
          border-right: 8px solid #fff;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          margin: 0 12px 0 31px;
        }

        span {
          font-weight: 400;
          font-size: 15px;
          color: #FFFFFF;
        }
      }

      .bot {
        display: flex;
        padding-top: 15px;
        align-items: center;

        img {
          width: 133px;
          height: 44px;
        }

        p {
          width: 0;
          height: 0;
          border-right: 8px solid #fff;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          margin: 0 12px 0 24px;
        }

        span {
          font-weight: 400;
          font-size: 15px;
          color: #fff;
        }
      }
    }
  }
}
</style>